import { useLayoutEffect, useState, Ref, useRef } from "react";

export interface IDimensions {
    width: number;
    height: number;
    top: number;
    left: number;
    x: number;
    y: number;
    right: number;
    bottom: number;
}

export function getDimensions(node: HTMLElement): IDimensions {

    return node.getBoundingClientRect();
}

export type UseDimensionsHook = [
    Ref<any>,
    IDimensions | undefined
]

export function useDimensions(): UseDimensionsHook {
    const [dimensions, setDimensions] = useState<IDimensions>();
    const ref = useRef<HTMLElement>();

    useLayoutEffect(() => {
        if (!ref.current) {
            return;
        }

        const measure = () => ref.current && setDimensions(getDimensions(ref.current));
        measure();

        const observer = new ResizeObserver(measure);
        observer.observe(ref.current);

        const innerRef = ref;
        return () => { innerRef.current && observer.unobserve(innerRef.current) }
    }, [ref]);

    return [ref, dimensions];
}